import { render, staticRenderFns } from "./materialMapping.vue?vue&type=template&id=4039ac90&scoped=true&"
import script from "./materialMapping.vue?vue&type=script&lang=js&"
export * from "./materialMapping.vue?vue&type=script&lang=js&"
import style0 from "./materialMapping.vue?vue&type=style&index=0&id=4039ac90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039ac90",
  null
  
)

export default component.exports